export default "__VITE_ASSET__8427600b__"